import Equifax from "../../assets/company-logos/Equifax.png";
import Experian from "../../assets/company-logos/Experian.png";
import TransUnion from "../../assets/company-logos/TransUnion.png";
import Illion from "../../assets/company-logos/Illion.png";
import Cortera from "../../assets/company-logos/Cortera.png";
import Creditsafe from "../../assets/company-logos/Creditsafe.png";
import Corelogic from "../../assets/company-logos/Corelogic.png";
import Verisk from "../../assets/company-logos/Verisk.png";
import LexisNexis from "../../assets/company-logos/LexisNexis.svg";
import Microbilt from "../../assets/company-logos/Microbilt.png";

const data = {
  usecaseInfo: {
    name: "Optimize Credit Decisioning",
    description: "A single platform to integrate and manage credit bureau feeds globally.",
  },
  recipesInfo: {
    title: "Make credit decisions",
    description:
      "Access API-ready solutions for consumer credit, business credit, and property risk available from bureaus in every region of the world.",
  },
  recipes: [
    {
      type: "People Data",
      title: "US Consumer Bureau",
      description:
        "Access US consumer bureau data from three leading data products: Equifax, Experian, and Transunion ",
    },
    {
      type: "Business Data",
      title: "Business Financials",
      description:
        "Demyst's Business Financials Product provides access to business credit information, firmographics, liens, and judgments, about a business to expedite business underwriting.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],
  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "TransUnion",
        img: TransUnion,
      },
      {
        name: "Illion",
        img: Illion,
      },
      {
        name: "Cortera",
        img: Cortera,
      },
      {
        name: "Creditsafe",
        img: Creditsafe,
      },
      {
        name: "Corelogic",
        img: Corelogic,
      },
      {
        name: "Verisk",
        img: Verisk,
      },
      {
        name: "LexisNexis",
        img: LexisNexis,
      },
      {
        name: "Microbilt",
        img: Microbilt,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Addressing Data Decay in Phone Numbers",
      url: "https://demyst.com/blog/what-happens-to-a-business-when-phone-numbers-are-inaccurate",
      featured_image: "https://cdn.buttercms.com/H4dlSKqhScyxR0M65gY6",
      date: "2021-10-9",
      description:
        "Phone numbers are a crucial component of marketing, customer relations, and account management. Indeed, apart from outbound email campaigns and Linkedin outreach, many organizations depend on phone calls for cold outreach campaigns. But in the B2B space, these records are continually changing, which can cause problems for the marketing campaigns that rely on them.",
      more: "",
    },
  ],
};

export default data;
